import React from 'react';
import { Home, ShoppingCart, ClipboardList, User } from 'lucide-react';

const tabs = [
  { id: 'home', label: 'Inicio', icon: Home },
  { id: 'cart', label: 'Carrito', icon: ShoppingCart },
  { id: 'orders', label: 'Órdenes', icon: ClipboardList },
  { id: 'profile', label: 'Perfil', icon: User },
];

const CustomerBottomNav = ({ activeTab, onTabChange, cartCount }) => {
  return (
    <nav className="fixed bottom-0 left-0 right-0 z-50 bg-white/95 backdrop-blur-xl border-t border-orange-100 safe-area-bottom">
      <div className="flex items-center justify-around h-16 max-w-lg mx-auto">
        {tabs.map((tab) => {
          const Icon = tab.icon;
          const isActive = activeTab === tab.id;
          return (
            <button
              key={tab.id}
              onClick={() => onTabChange(tab.id)}
              className={`relative flex flex-col items-center justify-center w-full h-full transition-all duration-200 ${
                isActive ? 'text-orange-500 scale-105' : 'text-gray-400 hover:text-gray-600'
              }`}
            >
              <div className="relative">
                <Icon className={`w-6 h-6 transition-transform duration-200 ${isActive ? 'drop-shadow-sm' : ''}`} />
                {tab.id === 'cart' && cartCount > 0 && (
                  <span className="absolute -top-2 -right-2 w-5 h-5 bg-red-500 text-white text-[10px] font-bold rounded-full flex items-center justify-center shadow-lg animate-pulse-once">
                    {cartCount > 9 ? '9+' : cartCount}
                  </span>
                )}
              </div>
              <span className={`text-[10px] mt-1 font-medium tracking-tight ${isActive ? 'font-bold' : ''}`}>
                {tab.label}
              </span>
              {isActive && (
                <span className="absolute top-0 left-1/2 -translate-x-1/2 w-8 h-0.5 bg-gradient-to-r from-orange-400 to-red-500 rounded-full" />
              )}
            </button>
          );
        })}
      </div>
    </nav>
  );
};

export default CustomerBottomNav;
